import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { TenantDto, SubscriptionDto } from './models/tenant.model';

export const TenantsActions = createActionGroup({
  source: 'Tenants',
  events: {
    Init: emptyProps(),
    'Set Query': props<{ query: string }>(),
    'Load Success': props<{ tenants: readonly TenantDto[] }>(),
    'Load Failure': props<{ error: unknown }>(),
    'Create Tenant': props<{
      tenantName: string;
      tenantDescription: string;
      tenantAvatarUrl: string;
      firstDayOfWeek: number;
    }>(),
    'Create Tenant Success': props<{ tenant: TenantDto }>(),
    'Create Tenant Failure': props<{ error: unknown }>(),
    'Delete Tenant': props<{ tenantId: string }>(),
    'Delete Tenant Success': props<{ tenantId: string }>(),
    'Delete Tenant Failure': props<{ error: unknown; tenantId: string }>(),
    'Update Tenant': props<{
      tenantId: string;
      changes: {
        tenantName: string;
        tenantDescription: string;
        tenantAvatarUrl: string;
        firstDayOfWeek: number;
        twoFactorRequired: boolean;
      };
    }>(),
    'Update Tenant Success': props<{ tenant: TenantDto }>(),
    'Update Tenant Failure': props<{ error: unknown; tenantId: string }>(),
    'Create Subscription': props<{ tenantId: string; subscriptionName: string }>(),
    'Create Subscription Success': props<{ tenantId: string; subscription: SubscriptionDto }>(),
    'Create Subscription Failure': props<{ error: unknown; tenantId: string }>(),
    Load: props<{
      query: string;
      filters: Record<string, unknown[]>;
      page: number;
      size: number;
    }>(),
    'Load Page Success': props<{
      tenants: readonly TenantDto[];
      totalElements: number;
      page: number;
      size: number;
    }>(),
    'Set Filters': props<{ filters: Record<string, unknown[]> }>(),
    Clear: emptyProps(),
  },
});
